import { Pipe, PipeTransform } from '@angular/core';
import { marked, Renderer } from 'marked';
import Prism from 'prismjs';

// Load additional Prism languages if needed
// import 'prismjs/components/prism-typescript';
// import 'prismjs/components/prism-markup';

@Pipe({ name: 'markdown', standalone: true })
export class MarkdownPipe implements PipeTransform {
  constructor() {
    // Custom renderer to open links in a new tab and add rel attributes
    const renderer = new Renderer();
    renderer.link = (href: string | null, title: string | null, text: string) => {
      const safeHref = href ?? '#';
      const titleAttr = title ? ` title="${title}"` : '';
      return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
    };

    // Highlight code blocks via custom renderer (marked v12 removed highlight option)
    renderer.code = (code: string, infostring: string | null, escaped?: boolean) => {
      const lang = (infostring || '').trim().split(/\s+/)[0];
      let highlighted = '';
      try {
        if (lang && Prism.languages[lang]) {
          highlighted = Prism.highlight(code, Prism.languages[lang], lang);
        } else {
          highlighted = code
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        }
      } catch {
        highlighted = code
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      }
      const classAttr = lang ? ` class="language-${lang}"` : '';
      return `<pre><code${classAttr}>${highlighted}</code></pre>`;
    };

    // Configure marked
    marked.setOptions({
      gfm: true,
      breaks: true,
      renderer
    });
  }

  transform(value: string | null | undefined): string {
    if (!value) return '';
    return marked.parse(value) as string;
  }
}
